(function () {
  'use strict';

  var REF_ATTRS = ['clip-path', 'mask', 'fill', 'stroke', 'filter', 'marker-start', 'marker-mid', 'marker-end', 'href', 'xlink:href'];
  function dedupeSvgIds() {
    var seen = {};
    var counter = 0;
    var nodes = document.querySelectorAll('svg [id]');
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var id = node.id;
      if (!id) continue;
      if (!seen[id]) {

        var first = document.getElementById(id);
        if (first === node || !first || first.closest('svg')) { seen[id] = true; continue; }
      }
      var newId = id + '-a11y' + (++counter);
      var svg = node.closest('svg');
      if (svg) {
        var all = svg.querySelectorAll('*');
        for (var a = 0; a < all.length; a++) {
          for (var r = 0; r < REF_ATTRS.length; r++) {
            var val = all[a].getAttribute(REF_ATTRS[r]);
            if (val && (val.indexOf('url(#' + id + ')') !== -1 || val === '#' + id)) {
              all[a].setAttribute(REF_ATTRS[r], val === '#' + id ? '#' + newId : val.split('url(#' + id + ')').join('url(#' + newId + ')'));
            }
          }
        }
      }
      node.id = newId;
    }
  }

  function fixFlickityFocus() {
    var sliders = document.querySelectorAll('.product-slideshow.flickity-enabled[tabindex="0"], .announcement-slider.flickity-enabled[tabindex="0"]');
    for (var i = 0; i < sliders.length; i++) {
      sliders[i].setAttribute('tabindex', '-1');
      if (!sliders[i].getAttribute('role')) {
        sliders[i].setAttribute('role', 'group');
        sliders[i].setAttribute('aria-roledescription', 'carousel');
        if (!sliders[i].getAttribute('aria-label')) {
          sliders[i].setAttribute('aria-label', sliders[i].classList.contains('product-slideshow') ? 'Product images' : 'Announcements');
        }
      }
    }
  }

  function labelFromPlaceholder() {
    var fields = document.querySelectorAll('input[placeholder]:not([type="hidden"]):not([aria-label]):not([aria-labelledby]), textarea[placeholder]:not([aria-label]):not([aria-labelledby])');
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i];
      var ph = (f.getAttribute('placeholder') || '').trim();
      if (!ph) continue;
      var named = false;
      var emptyLabel = null;
      if (f.id) {
        var labels = document.querySelectorAll('label[for="' + f.id.replace(/"/g, '\\"') + '"]');
        for (var l = 0; l < labels.length; l++) {
          if (labels[l].textContent.trim()) named = true;
          else emptyLabel = labels[l];
        }
      }
      if (!named && f.closest('label') && f.closest('label').textContent.trim()) named = true;
      if (named) continue;
      if (emptyLabel) {
        emptyLabel.textContent = ph;
      } else {
        f.setAttribute('aria-label', ph);
      }
    }
  }

  function labelCaptchaFields() {
    var fields = document.querySelectorAll('textarea[name^="h-captcha-response"]:not([aria-label]), textarea[name^="g-recaptcha-response"]:not([aria-label])');
    for (var i = 0; i < fields.length; i++) {
      fields[i].setAttribute('aria-label', 'Captcha response');
      fields[i].setAttribute('tabindex', '-1');
    }
  }

  function fixExtraBanners() {
    var headers = document.querySelectorAll('header.wizard__header:not([role])');
    for (var i = 0; i < headers.length; i++) {
      if (!headers[i].closest('main, article, section, aside, nav')) headers[i].setAttribute('role', 'presentation');
    }
  }

  function fixGloboParagraphs() {
    var paras = document.querySelectorAll('.globo-paragraph[tabindex="0"], .globo-form-app [class*="globo-paragraph"][tabindex="0"]');
    for (var i = 0; i < paras.length; i++) paras[i].removeAttribute('tabindex');
  }

  function titleIframes() {
    var frames = document.querySelectorAll('iframe:not([title]), iframe[title=""]');
    for (var i = 0; i < frames.length; i++) {
      var src = frames[i].getAttribute('src') || '';
      var label = 'Embedded content';
      if (/hcaptcha\.com/i.test(src)) label = 'hCaptcha';
      else if (/youtube(-nocookie)?\.com|youtu\.be/i.test(src)) label = 'YouTube video';
      else if (/vimeo\.com/i.test(src)) label = 'Vimeo video';
      else if (/google\.com\/maps/i.test(src)) label = 'Google Maps';
      else if (/googletagmanager/i.test(src)) label = 'Google Tag Manager (hidden)';
      frames[i].setAttribute('title', label);
    }
  }

  function activateVideoFacade(facade) {
    if (!facade || facade.getAttribute('data-video-loaded')) return;
    facade.setAttribute('data-video-loaded', 'true');
    var iframe = document.createElement('iframe');
    iframe.src = facade.getAttribute('data-video-src');
    iframe.title = facade.getAttribute('data-video-title') || 'Video';
    iframe.width = '850';
    iframe.height = '480';
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
    iframe.setAttribute('tabindex', '0');
    facade.parentNode.replaceChild(iframe, facade);
    try { iframe.focus(); } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-video-facade] .video-facade__play, [data-video-facade] .video-facade__poster');
    if (btn) {
      e.preventDefault();
      activateVideoFacade(btn.closest('[data-video-facade]'));
    }
  });

  var CUSTOMILY_SEL = '.customily-modal-container';
  var CUSTOMILY_FOCUSABLE = 'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var customilyOpener = null;
  var customilyWasOpen = false;

  function customilyModal() {
    var m = document.querySelector(CUSTOMILY_SEL);
    return m && getComputedStyle(m).display !== 'none' ? m : null;
  }
  function customilyVisible(el) {
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }
  function customilyFocusables(modal) {
    return Array.prototype.filter.call(modal.querySelectorAll(CUSTOMILY_FOCUSABLE), customilyVisible);
  }
  function customilyCloseButton(modal) {
    var btns = modal.querySelectorAll('.customily-close-button, .close-btn');
    for (var i = 0; i < btns.length; i++) if (customilyVisible(btns[i])) return btns[i];
    return null;
  }
  function customilyCleanName(text) {
    return text.replace(/\(\d+\|\d+\)/g, '').replace(/\*/g, '').replace(/\bRequired\b/g, '').replace(/\s+/g, ' ').trim();
  }
  function customilyOptionName(el) {
    var opt = el.closest('.customily_option');
    var name = opt && opt.querySelector('.option_name');
    return name ? customilyCleanName(name.textContent) : '';
  }
  function customilyDescribePreview(modal) {
    var parts = [];
    var opts = modal.querySelectorAll('.customily_option');
    for (var i = 0; i < opts.length; i++) {
      var name = customilyCleanName((opts[i].querySelector('.option_name') || {}).textContent || '');
      var value = '';
      var text = opts[i].querySelector('input[type="text"], textarea');
      var checked = opts[i].querySelector('input[type="radio"]:checked');
      var select = opts[i].querySelector('select');
      if (text) value = text.value;
      else if (checked) value = checked.value;
      else if (select) value = select.options[select.selectedIndex] ? select.options[select.selectedIndex].text : '';
      if (name && value) parts.push(name + ': ' + value);
    }
    var product = document.querySelector('h1');
    var title = product ? product.textContent.trim() : 'product';
    return 'Live preview of your personalized ' + title + (parts.length ? '. ' + parts.join('. ') : '. No options chosen yet') + '.';
  }
  function customilyLabelPreview(modal) {
    var wraps = modal.querySelectorAll('.canvas-container');
    var text = customilyDescribePreview(modal);
    for (var i = 0; i < wraps.length; i++) {
      wraps[i].setAttribute('role', 'img');
      wraps[i].setAttribute('aria-label', text);
      var cvs = wraps[i].querySelectorAll('canvas');
      for (var c = 0; c < cvs.length; c++) cvs[c].setAttribute('aria-hidden', 'true');
    }
  }
  function customilyLabelSwatches(modal) {
    var groups = modal.querySelectorAll('.swatch-container');
    for (var g = 0; g < groups.length; g++) {
      var group = groups[g];
      if (!group.getAttribute('aria-label')) {
        var name = customilyOptionName(group);
        if (name) group.setAttribute('aria-label', name);
      }
      var swatches = group.querySelectorAll('.customily-swatch');
      for (var s = 0; s < swatches.length; s++) {
        var radio = swatches[s].querySelector('input[type="radio"]');
        var img = swatches[s].querySelector('img');
        swatches[s].setAttribute('role', 'radio');
        swatches[s].setAttribute('aria-checked', radio && radio.checked ? 'true' : 'false');
        var label = (radio && radio.value) || (img && img.getAttribute('alt')) || (swatches[s].getAttribute('title')) || '';
        if (label) swatches[s].setAttribute('aria-label', label);
      }
      var desc = group.getAttribute('aria-describedby');
      if (!desc) group.setAttribute('aria-roledescription', 'option group, use arrow keys to change');
    }
  }
  function customilyMoveSwatch(group, dir) {
    var swatches = Array.prototype.filter.call(group.querySelectorAll('.customily-swatch'), customilyVisible);
    if (!swatches.length) return;
    var idx = -1;
    for (var i = 0; i < swatches.length; i++) {
      var r = swatches[i].querySelector('input[type="radio"]');
      if (r && r.checked) { idx = i; break; }
    }
    var next = idx < 0 ? 0 : (idx + dir + swatches.length) % swatches.length;
    var target = swatches[next].querySelector('img') || swatches[next];
    target.click();
  }
  function customilyOnOpen(modal) {
    customilyOpener = document.activeElement && document.activeElement !== document.body ? document.activeElement : document.getElementById('customily-personalize-button');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    var h1 = document.querySelector('h1');
    modal.setAttribute('aria-label', 'Personalize ' + (h1 ? h1.textContent.trim() : 'this product'));
    var close = customilyCloseButton(modal);
    if (close) {
      close.setAttribute('role', 'button');
      close.setAttribute('tabindex', '0');
      close.setAttribute('aria-label', 'Close personalization');
    }
    customilyLabelSwatches(modal);
    customilyLabelPreview(modal);
    var items = customilyFocusables(modal);
    var first = items.filter(function (i) { return i !== close; })[0] || items[0];
    if (first) setTimeout(function () { try { first.focus(); } catch (e) {} }, 50);
  }
  function customilyOnClose() {
    if (customilyOpener && document.contains(customilyOpener)) {
      try { customilyOpener.focus(); } catch (e) {}
    }
    customilyOpener = null;
  }
  function customilyFixOptionLabels(modal) {
    var labels = modal.querySelectorAll('label[role="button"], label[aria-expanded], label[aria-controls]');
    for (var i = 0; i < labels.length; i++) {
      if (labels[i].tabIndex < 0) {
        labels[i].removeAttribute('role');
        labels[i].removeAttribute('aria-expanded');
        labels[i].removeAttribute('aria-controls');
      }
    }
  }
  function customilyNameControls(modal) {
    var labels = modal.querySelectorAll('.customily-swatch label');
    for (var i = 0; i < labels.length; i++) {
      var lab = labels[i];
      if (lab.textContent.trim() || lab.querySelector('img[alt]:not([alt=""])') || lab.querySelector('.a11y-swatch-name')) continue;
      var radio = lab.getAttribute('for') ? document.getElementById(lab.getAttribute('for')) : null;
      var value = (radio && radio.value) || lab.parentElement.getAttribute('aria-label') || '';
      if (!value) continue;
      var span = document.createElement('span');
      span.className = 'visually-hidden a11y-swatch-name';
      span.textContent = value;
      lab.appendChild(span);
    }
    var btns = modal.querySelectorAll('button.options-control-button:not([aria-label])');
    for (var b = 0; b < btns.length; b++) {
      if (btns[b].textContent.trim()) continue;
      btns[b].setAttribute('aria-label', btns[b].classList.contains('options-control-preview-button') ? 'Show preview' : 'Show product options');
    }
    var shares = { 'pinterest-share-link': 'Share on Pinterest', 'twitter-share-link': 'Share on X', 'facebook-share-link': 'Share on Facebook' };
    for (var id in shares) {
      var a = document.getElementById(id);
      if (a && !a.getAttribute('aria-label') && !a.textContent.trim()) a.setAttribute('aria-label', shares[id]);
    }
  }
  function customilySync() {
    var container = document.querySelector(CUSTOMILY_SEL);
    if (container) { customilyLabelSwatches(container); customilyFixOptionLabels(container); customilyNameControls(container); }
    var modal = customilyModal();
    var open = !!modal;
    if (open && !customilyWasOpen) customilyOnOpen(modal);
    if (!open && customilyWasOpen) customilyOnClose();
    if (open) customilyLabelPreview(modal);
    customilyWasOpen = open;
  }
  document.addEventListener('keydown', function (e) {
    var modal = customilyModal();
    if (!modal) return;
    var t = e.target;
    if (e.key === 'Escape') {
      var close = customilyCloseButton(modal);
      if (close) { e.preventDefault(); close.click(); }
      return;
    }
    if ((e.key === 'Enter' || e.key === ' ') && t.classList && (t.classList.contains('customily-close-button') || t.classList.contains('close-btn'))) {
      e.preventDefault(); t.click(); return;
    }
    if (t.classList && t.classList.contains('swatch-container')) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); customilyMoveSwatch(t, 1); return; }
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); customilyMoveSwatch(t, -1); return; }
    }
    if (e.key === 'Tab') {
      var items = customilyFocusables(modal);
      if (!items.length) return;
      var idx = items.indexOf(document.activeElement);
      if (e.shiftKey) {
        if (idx <= 0) { e.preventDefault(); items[items.length - 1].focus(); }
      } else {
        if (idx === -1 || idx === items.length - 1) { e.preventDefault(); items[0].focus(); }
      }
    }
  }, true);
  document.addEventListener('input', function (e) { var m = customilyModal(); if (m && m.contains(e.target)) customilyLabelPreview(m); }, true);
  document.addEventListener('change', function (e) { var m = customilyModal(); if (m && m.contains(e.target)) { customilyLabelSwatches(m); customilyLabelPreview(m); } }, true);

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    var run = function () {
      scheduled = false;
      dedupeSvgIds();
      fixFlickityFocus();
      labelFromPlaceholder();
      labelCaptchaFields();
      fixExtraBanners();
      fixGloboParagraphs();
      titleIframes();
      customilySync();
    };
    if (document.hidden) { setTimeout(run, 0); } else { window.requestAnimationFrame(run); }
  }

  function start() {
    schedule();
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['tabindex', 'style', 'class'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();